<template>
  <div>
    <wc-page-title title='Dashboard'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12' md='4'>
          <wc-data-box
            title='Active Schedules'
            titleIcon='mdi-calendar'
            :loading='isLoading'
          >
            <v-card
              v-for='s in schedules' :key='s.id'
              color="grey lighten-4"
              flat
              tile
            >
              <v-btn
                block
                depressed
                @click='openSchedule(s)'
              >
                {{ s.name }}
              </v-btn>
            </v-card>
          </wc-data-box>
        </v-col>

        <v-col cols='12' md='4'>
          <wc-data-box
            title='Project Routing'
            titleIcon='mdi-routes'
            titleIconColor='primary'
          >
            <v-card
              v-for='div in filteredDivisions' :key='div.id'
              color="grey lighten-4"
              flat
              tile
            >
              <v-btn
                block
                depressed
                @click='openRoutingPage(div.id)'
              >
                {{ div.division }}
                {{ div.division === 'Lawn' ? ' ( & mowing schedule)' : ''}}
                {{ div.division === 'Snow' ? ' ( & shovelling schedule)' : ''}}
              </v-btn>
            </v-card>
          </wc-data-box>

          <wc-data-box
            title='Calendars'
            titleIcon='mdi-calendar'
            titleIconColor='primary'
            class='mt-6'
          >
            <v-card
              v-for='cal in calendars' :key='cal.id'
              color="grey lighten-4"
              flat
              tile
            >
              <v-btn
                block
                depressed
                @click='openCalendar(cal)'
              >
                {{ cal.name }}
              </v-btn>
            </v-card>
          </wc-data-box>
        </v-col>

        <v-col cols='12' md='4'>
          <v-card>
            <v-card-title class='info--text'>
              Snow Rating Update
            </v-card-title>
            <v-card-text class='primary--text'>
              Snow projects now display their rating, and the group shows the ratings total of projects contained within.
              <!-- <v-icon right small class='icon mt-n1' color='primary'>mdi-key-variant</v-icon> -->
              <br><br>
              Field crews will now see the rating and the time on site for each project on their snow route<br><br>
              <!-- <i class='grey--text'></i> -->
              <!-- <br><br> -->
              <!-- <span class='grey--text'></span> -->
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import scheduleAPI from '@/modules/schedule/api/schedule'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'schedule-dashboard',
  data: () => ({
    isLoading: true,
    schedules: [],
    calendars: [],
    routedDivisions: [ 'Irrigation', 'Lawn', 'Snow' ]
  }),
  computed: {
    date () {
      return moment().format('YYYY-MM-DD').toString()
    },
    divisions () {
      return _.orderBy(this.$store.state.misc.divisions, 'order')
    },
    filteredDivisions () {
      return _.filter(this.divisions, d => _.includes(this.routedDivisions, d.division)) 
    }
  },
  mounted () {
    this.getSchedules()
  },
  methods: {
    async getSchedules () {
      this.isLoading = true
      let tmp = await scheduleAPI.getSchedules()
      this.schedules = _.filter(tmp, s => s.is_archived === false && s.division)
      this.calendars = _.filter(tmp, s => s.is_archived === false && !s.division)
      this.isLoading = false
    },
    async openSchedule(schedule) {
      this.$router.push({ name: 'ScheduleDay', params: { id: schedule.id, date: this.date } })
    },
    async openRoutingPage(divisionID) {
      this.$router.push({ name: 'DivisionRoutingPage', params: { id: divisionID } })
    },
    openCalendar(calendar) {
      console.log(calendar)
      this.$router.push({ name: 'OfficeCalendar', params: { id: calendar.id, date: this.date } })
    }
  },
}
</script>
